import React from "react";
import { View } from "react-native";

interface PlusBlackProps {
  size?: number;
}

const PlusBlack: React.FC<PlusBlackProps> = ({ size = 25 }) => {
  return (
    <View style={{ width: size, height: size }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6 12H12M12 12H18M12 12V6M12 12V18"
          stroke="#000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </View>
  );
};

export default PlusBlack;
